export default "__VITE_ASSET__BtsNrWrd__"